import { GetterTree } from "vuex";
import { RootState } from "../types";
import { CandidatesWithoutJobInt } from "./types";
export const getters: GetterTree<CandidatesWithoutJobInt, RootState> = {};
